// File: src/components/home/MachineCTA.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './MachineCTA.module.css';
import ScrollAnimation from '../common/ScrollAnimation';
import { ASSETS_BASE_URL } from '../../config/constants';

const MACHINE_IMAGES = [
  { src: `${ASSETS_BASE_URL}/gs-digester-front-view-clear-background.png`,    alt: 'GS Digester — front view' },
  { src: `${ASSETS_BASE_URL}/gs-digester-diagonal-view-clear-background.png`, alt: 'GS Digester — diagonal view' },
  { src: `${ASSETS_BASE_URL}/gs-digester-side-shot-clear-background.png`,     alt: 'GS Digester — side view' },
];

function MachineCTA() {
  const [active, setActive] = useState(0);

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        {/* ── Left: text ── */}
        <div className={styles.textCol}>
          <ScrollAnimation>
            <p className={styles.eyebrow}>The GS Digester</p>
            <h2 className={styles.heading}>
              Turn your organic waste into a sustainable future.
            </h2>
            <p className={styles.body}>
              GreenScience's proprietary, urban-friendly recycling technology processes organic waste through scalable facilities—from mid-sized operations to large regional facilities—operating odourlessly, silently, and continuously to convert waste into high-value worm castings and carbon credits.
            </p>
          </ScrollAnimation>
          <ScrollAnimation delay={120}>
            <div className={styles.actions}>
              <Link to="/solution" className={styles.primaryBtn}>
                See How It Works
              </Link>
              <Link to="/contact" className={styles.secondaryBtn}>
                Request a Demo →
              </Link>
            </div>
          </ScrollAnimation>
          <ScrollAnimation delay={200}>
            <div className={styles.proofPoints}>
              <div className={styles.proof}>
                <span className={styles.proofValue}>100%</span>
                <span className={styles.proofLabel}>Organic waste diverted</span>
              </div>
              <div className={styles.proofDivider} />
              <div className={styles.proof}>
                <span className={styles.proofValue}>0</span>
                <span className={styles.proofLabel}>Odour &amp; noise</span>
              </div>
              <div className={styles.proofDivider} />
              <div className={styles.proof}>
                <span className={styles.proofValue}>3×</span>
                <span className={styles.proofLabel}>Revenue streams</span>
              </div>
            </div>
          </ScrollAnimation>
        </div>

        {/* ── Right: image carousel ── */}
        <ScrollAnimation className={styles.imageCol} delay={80}>
          <div className={styles.imageCard}>

            {/* Badge row */}
            <div className={styles.badgeRow}>
              <div className={styles.badge}>
                <span className={styles.badgeDot} />
                Patented Technology
              </div>
            </div>

            {/* Image row */}
            <div className={styles.imageRow}>
              <img
                src={MACHINE_IMAGES[active].src}
                alt={MACHINE_IMAGES[active].alt}
                className={styles.image}
              />
            </div>

            {/* Number buttons row */}
            <div className={styles.numbersRow}>
              {MACHINE_IMAGES.map((img, i) => (
                <button
                  key={i}
                  className={`${styles.numBtn} ${i === active ? styles.numBtnActive : ''}`}
                  onClick={() => setActive(i)}
                  aria-label={img.alt}
                >
                  {i + 1}
                </button>
              ))}
            </div>

          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}

export default MachineCTA;